/* ======================================================================
   OFFSET LIMITLESS product page sections (offset-lx-*)
   One small script for every section. Each section calls window.OffsetLX
   with its own root element, so nothing here assumes a section exists.
   Safe to load more than once: the guard below makes it a no-op.
   ====================================================================== */
(function () {
  if (window.OffsetLX) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal on scroll, once */
  function reveal(root) {
    var els = [].slice.call(root.querySelectorAll('.lx__rv'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* run fn once when root scrolls into view, then on every click of [data-lx-replay] inside it */
  function whenInView(root, fn, threshold) {
    if (!('IntersectionObserver' in window)) { fn(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { fn(); io.unobserve(root); } });
    }, { threshold: threshold || .4 });
    io.observe(root);
  }

  /* smooth scroll to the product form (main-product section) or the top of the page */
  function scrollToBuy(e) {
    // JSON templates name the product section "shopify-section-template--<id>__main"; fall back to the add to cart form, then the top
    var target = document.querySelector('[id^="shopify-section-template--"][id$="__main"]') || document.getElementById('shopify-section-main') || document.querySelector('form[action*="/cart/add"]');
    if (e) e.preventDefault();
    var top = target ? target.getBoundingClientRect().top + window.pageYOffset - 12 : 0;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }


  /* scroll to the full Judge.me review list (the "apps" section holding the widget) */
  function scrollToReviews(e) {
    var target = document.querySelector('.jdgm-widget, .jdgm-rev-widg, [class*="jdgm-review-widget"]');
    if (target) target = target.closest('.shopify-section') || target;
    if (e) e.preventDefault();
    if (!target) return;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---- reviews rail: arrows scroll one card at a time ---- */
  function reviews(root) {
    var track = root.querySelector('[data-lx-rail]'); if (!track) return;
    var prev = root.querySelector('[data-lx-rail-prev]'), next = root.querySelector('[data-lx-rail-next]');
    function step() { var card = track.querySelector('.lx-revs__card'); return card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) : 300; }
    function update() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- spin time animation ---- */
  function spin(root) {
    function play() { root.classList.remove('is-playing'); void root.offsetWidth; root.classList.add('is-playing'); }
    whenInView(root, play, .4);
    // one button under each panel; either one replays both
    [].slice.call(root.querySelectorAll('[data-lx-replay]')).forEach(function (btn) { btn.addEventListener('click', play); });
  }

  /* ---- 60mm catch zone animation: five identical throws ---- */
  function catchZone(root) {
    var NS = 'http://www.w3.org/2000/svg';
    var INK = '#0a0a0a';
    var ACC = root.getAttribute('data-accent') || '#0017E8';
    var GREY = '#6e6e73';
    var TOP = 80, BOT = 300, MID = 190, GAP = 8, NARROW = 84, WIDE = 120, OFF = [-30, 70, -100, 40, 110];
    var gn = root.querySelector('[data-lx-narrow]'), gw = root.querySelector('[data-lx-wide]');
    var sc = root.querySelector('[data-lx-score-narrow]'), wc = root.querySelector('[data-lx-score-wide]');
    var wordNarrow = root.getAttribute('data-word-narrow') || 'NARROWER';
    var wordWide = root.getAttribute('data-word-wide') || '60MM WIDE';
    var landed = root.getAttribute('data-word-landed') || 'Landed';
    if (!gn || !gw) return;

    function el(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }
    function yoyo(g, cx, half, accent, word) {
      var L = cx - half, R = cx + half;
      var body = el('g', { fill: INK, stroke: INK, 'stroke-width': 12, 'stroke-linejoin': 'round' }, g);
      el('path', { d: 'M ' + L + ' ' + TOP + ' L ' + (cx - 4) + ' ' + (MID - GAP) + ' L ' + (cx - 4) + ' ' + (MID + GAP) + ' L ' + L + ' ' + BOT + ' Z' }, body);
      el('path', { d: 'M ' + R + ' ' + TOP + ' L ' + (cx + 4) + ' ' + (MID - GAP) + ' L ' + (cx + 4) + ' ' + (MID + GAP) + ' L ' + R + ' ' + BOT + ' Z' }, body);
      el('rect', { x: cx - 6, y: MID - GAP, width: 12, height: 2 * GAP, fill: INK }, g);
      var y = TOP - 28, a = el('g', { stroke: accent, 'stroke-width': 6, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', fill: 'none' }, g);
      el('path', { d: 'M ' + L + ' ' + y + ' H ' + R }, a);
      el('path', { d: 'M ' + (L + 14) + ' ' + (y - 12) + ' L ' + L + ' ' + y + ' L ' + (L + 14) + ' ' + (y + 12) }, a);
      el('path', { d: 'M ' + (R - 14) + ' ' + (y - 12) + ' L ' + R + ' ' + y + ' L ' + (R - 14) + ' ' + (y + 12) }, a);
      var t = el('text', { x: cx, y: y - 16, 'text-anchor': 'middle', fill: accent, 'font-size': 12, 'font-weight': 600, 'letter-spacing': 1.4, 'font-family': 'GeneralSans, Helvetica, Arial, sans-serif' }, g);
      t.textContent = word;
    }
    function string(g, x, y1, y2) {
      var s = el('g', { 'class': 'lx-catch__str' }, g);
      el('path', { d: 'M ' + x + ' ' + y1 + ' L ' + x + ' ' + y2, fill: 'none', stroke: '#fff', 'stroke-width': 18, 'stroke-linecap': 'round' }, s);
      el('path', { d: 'M ' + x + ' ' + y1 + ' L ' + x + ' ' + y2, fill: 'none', stroke: INK, 'stroke-width': 10, 'stroke-linecap': 'round' }, s);
      return s;
    }
    function mark(g, x, y, hit, accent) {
      var m = el('g', { 'class': 'lx-catch__mk' }, g);
      if (hit) el('circle', { cx: x, cy: y, r: 7, fill: accent }, m);
      else el('path', { d: 'M ' + (x - 7) + ' ' + (y - 7) + ' l 14 14 M ' + (x + 7) + ' ' + (y - 7) + ' l -14 14', stroke: INK, 'stroke-width': 3, 'stroke-linecap': 'round', fill: 'none' }, m);
      return m;
    }
    var timers = [];
    function later(fn, ms) { timers.push(setTimeout(fn, ms)); }
    function draw() { gn.innerHTML = ''; gw.innerHTML = ''; yoyo(gn, 200, NARROW, GREY, wordNarrow); yoyo(gw, 600, WIDE, ACC, wordWide); }
    function play() {
      timers.forEach(clearTimeout); timers = [];
      draw();
      var sn = string(gn, 200, -40, MID - 30), sw = string(gw, 600, -40, MID - 30);
      sn.style.transform = 'translate(-30px,-120px)'; sw.style.transform = 'translate(-30px,-120px)';
      var hn = 0, hw = 0;
      if (sc) sc.textContent = landed + ' 0 of 5'; if (wc) wc.textContent = landed + ' 0 of 5';
      OFF.forEach(function (off, i) {
        var t0 = 500 + i * 1150, hitN = Math.abs(off) <= NARROW;
        later(function () { sn.style.transform = 'translate(' + off + 'px,-120px)'; sw.style.transform = 'translate(' + off + 'px,-120px)'; }, t0);
        later(function () { sn.style.transform = 'translate(' + off + 'px,' + (hitN ? 0 : 150) + 'px)'; sw.style.transform = 'translate(' + off + 'px,0px)'; }, t0 + 380);
        later(function () {
          if (hitN) hn++; hw++;
          if (sc) sc.textContent = landed + ' ' + hn + ' of 5'; if (wc) wc.textContent = landed + ' ' + hw + ' of 5';
          mark(gn, 200 + off, BOT + 22, hitN, INK).classList.add('is-on');
          mark(gw, 600 + off, BOT + 22, true, ACC).classList.add('is-on');
        }, t0 + 820);
      });
    }
    draw();
    whenInView(root, play, .5);
    var btn = root.querySelector('[data-lx-replay]');
    if (btn) btn.addEventListener('click', play);
  }

  /* ---- final buy section: colour picker ---- */
  function buy(root) {
    var imgs = [].slice.call(root.querySelectorAll('[data-lx-colour-img]'));
    var btns = [].slice.call(root.querySelectorAll('[data-lx-colour]'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var c = b.getAttribute('data-lx-colour');
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        imgs.forEach(function (im) { if (im.getAttribute('data-lx-colour-img') === c) im.removeAttribute('data-off'); else im.setAttribute('data-off', ''); });
      });
    });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-lx-ready')) return;
    root.setAttribute('data-lx-ready', '');
    reveal(root);
    [].slice.call(root.querySelectorAll('[data-lx-scroll-buy]')).forEach(function (a) { a.addEventListener('click', scrollToBuy); });
    [].slice.call(root.querySelectorAll('[data-lx-scroll-reviews]')).forEach(function (a) { a.addEventListener('click', scrollToReviews); });
    var kind = root.getAttribute('data-lx');
    if (kind === 'spin') spin(root);
    if (kind === 'catch') catchZone(root);
    if (kind === 'buy') buy(root);
    if (kind === 'reviews') reviews(root);
  }

  window.OffsetLX = { init: init };

  /* boot every section already on the page, and re-run when the theme editor re-renders one */
  function boot() { [].slice.call(document.querySelectorAll('[data-lx]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-lx]'); if (r) { r.removeAttribute('data-lx-ready'); init(r); } });
})();
